// import styles
import './styles.scss';

// inport jquery
import $ from 'jquery';
// import bootstrap
import 'bootstrap';

$(function () {
    $('.icon-show-menu').on('click', () => {
        $('.navbar').toggleClass('opened');
        $('body').toggleClass('overflow-hidden');
        $('.navbar-primary, .navbar-secondary').toggleClass('d-none');
    });

    $('.search-show-icon').on('click', () => {
        $('#searchbar').css("display", "flex").fadeIn(200);
        $('#searchbar input').trigger('focus');
    });

    $('.search-hide-icon').on('click', () => {
        $('#searchbar').fadeOut(200);
    });

    $("table").wrap("<div class='table-responsive'></div>");

    //on load, show backToTopButton if needed
    if ($(window)?.scrollTop() ?? 0 >= 1000) {
        $('#backToTopButton').css('visibility', 'visible');
    }

    $(window).on('scroll', () => {
        if ($(window)?.scrollTop() ?? 0 >= 1000) {
            if ($('#backToTopButton').css('visibility') !== 'visible') {
                $('#backToTopButton').css('visibility', 'visible');
            }
        } else {
            if ($('#backToTopButton').css('visibility') !== 'hidden') {
                $('#backToTopButton').css('visibility', 'hidden');
            }
        }
    });

});